/** Central TanStack Query keys — use for invalidation and stable cache identity. */
export const queryKeys = {
  toolkit: {
    catalog: ['toolkit', 'catalog'],
  },
  notes: {
    all: ['notes'],
    detail: (id) => ['notes', id],
  },
  auth: {
    whoami: ['auth', 'whoami'],
  },
}
